import { useState, useEffect } from "react";
import {
  Button,
  Box,
  Typography,
  TextField,
  Avatar,
  Menu,
} from "@mui/material";
import { UseProductColor } from "./UseProductColor";
import { useNavigate, useLocation } from "react-router-dom";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { rsGotoLast, rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { SketchPicker } from "react-color";
import useBreakpoints from "../../hooks/useBreakpoints";

function AddProductColor() {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const navigate = useNavigate();
  const location = useLocation();
  const [color, setColor] = useState();
  const { validate, addColor } = UseProductColor();
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { isSmall } = useBreakpoints();

  const [state, setState] = useState({
    id: undefined,
    faName: undefined,
    enName: undefined,
    color: undefined,
    colorCode: undefined,
  });

  const [errorState, setErrorState] = useState({
    faName: false,
    enName: false,
  });

  return (
    <Detail
      breadChilds={{
        title: "اطلاعات پایه",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/productcolors" },
          { name: "رنگ جدید", url: "/productcolors/addproductcolor" },
        ],
      }}
    >
      {!color ? (
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              value={state.faName ? state.faName : ""}
              error={errorState.faName}
              label="نام فارسی"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, faName: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              value={state.enName ? state.enName : ""}
              error={errorState.enName}
              sx={{
                input: { direction: "rtl" },
              }}
              label="نام لاتین"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, enName: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              value={state.colorCode ? state.colorCode : ""}
              error={errorState.colorCode}
              sx={{
                input: { direction: "rtl" },
              }}
              label=" کد رنگ"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, colorCode: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Typography
                sx={{ color: errorState.color == true ? "red" : "#565656" }}
                variant="body1"
              >
                رنگ:
              </Typography>
              <Avatar
                sx={{
                  bgcolor: state.color,
                  boxShadow: 3,
                  width: 35,
                  height: 35,
                  mx: 1,
                }}
                id="basic-button"
                aria-controls={open ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={(event) => setAnchorEl(event.currentTarget)}
              >
                {" "}
              </Avatar>
              <Typography variant="body1">{state.color}</Typography>
            </Box>
            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={() => setAnchorEl(null)}
              sx={{
                "& .muirtl-6hp17o-MuiList-root-MuiMenu-list": {
                  py: 0,
                },
              }}
            >
              <SketchPicker
                sx={{ position: "relative", top: "-130px" }}
                color={state.color}
                onChangeComplete={(color) => {
                  setState({ ...state, color: color.hex });
                }}
              />
            </Menu>
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box
            gridColumn={isSmall ? "span 12" : "span 3"}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              sx={{ mr: 2, width: "100px" }}
              variant="contained"
              color="secondary"
              onClick={() => {
                if (validate(state, setErrorState) == 200) {
                  setProgress(true);
                  setMsGotoLast(true);
                  addColor(state, () => {
                    navigate("/productcolors", {
                      state: { ...location.state, isBack: true },
                      replace: true,
                    });
                  });
                }
              }}
            >
              ثبت
            </Button>
            <Button
              sx={{ width: "100px" }}
              variant="outlined"
              color="secondary"
              onClick={() => {
                navigate("/productcolors", {
                  state: { ...location.state, isBack: true },
                  replace: true,
                });
              }}
            >
              بازگشت
            </Button>
          </Box>
        </Box>
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}

export default AddProductColor;
